import * as React from "react";

import { ExpertNoteContainer } from "./ExpertNoteContainer";
import { MessageBox } from "./MessageBox";
import { NavigateLink } from "./NavigateLink";

export function Name(props: { children: JSX.Element }): JSX.Element {
    return <div>{props.children}</div>;
}

// @ts-ignore
ExpertNoteContainer.Name = Name;
// @ts-ignore
ExpertNoteContainer.MessageBox = MessageBox;
// @ts-ignore
ExpertNoteContainer.Link = NavigateLink;

export { ExpertNoteContainer };
